<template>
  <main>
    <s-popover position="top" animation="slide-y" >
      <template #activator>
        <div class="topbar-usuario-activator" style="cursor: pointer;">
          <img
            v-if="user?.avatar?.icone && !avatarFalhou"
            :src="avatarPath"
            alt=""
            class="activator-avatar"
            @error="avatarFalhou = true"
          />
          <s-icon v-else icon="mdiAccountCircleOutline" size="large" color="text-tertiary" />

          <span class="activator-texto">
            <strong>{{ primeiroNome }}</strong>
            <small>{{ user?.tipo?.nome }}</small>
          </span>
          <s-icon icon="mdiChevronDown" size="small" color="text-tertiary" />
        </div>
      </template>

      <template #content>
        <div class="topbar-usuario-content">
          <div class="topbar-usuario-container">
            <img 
              :src="avatarPath"
              alt="Avatar" 
              width="60"
              height="60"
              class="usuario-avatar"
            />

            <div class="topbar-usuario-text">
              <h3 class="topbar-usuario-name">
                {{ (user) ? user.nome : '' }}
              </h3>
              <p class="topbar-usuario-role">
                {{ (user && user.tipo) ? user.tipo.nome : '' }}
              </p>
              <p class="topbar-usuario-email" :title="user?.email">
                {{ (user) ? user.email : '' }}
              </p>
            </div>
          </div>
          
          <hr>

          <div class="topbar-usuario-actions">
            <s-button
              variant="text"
              color="text-secondary"
              label="Meu perfil"
              icon="mdiAccountCircleOutline"
              @click="perfil = true"
              class="topbar-usuario-button"
            />
            <s-button
              variant="text"
              color="text-secondary"
              label="Alterar Senha"
              icon="mdiLockReset"
              @click="showModal()"
              class="topbar-usuario-button"
            />
            <s-button
              variant="text"
              color="error"
              label="Sair"
              icon="mdiLogout"
              @click="logout"
              class="topbar-usuario-button"
            />
          </div>

          <footer class="topbar-usuario-versao">
            <s-icon icon="mdiInformationOutline" size="x-small" color="text-tertiary" />
            Portal Quinyx · versão {{ version }}
          </footer>
        </div>
      </template>
    </s-popover>
  </main>
  <Teleport to="body">
    <AuthPasswordChange :id="currentId" v-model="modal" />
    <AuthPerfil v-model="perfil" />
  </Teleport>
</template>

<script setup lang="ts">

import { SPopover, SIcon, SButton } from '@sieg-ad/componentes-vue';
import { AuthPasswordChange } from '#components';
import { useAuthStore } from '~/stores/auth';

// COMPOSABLES

const authStore = useAuthStore();

// REFS

const currentId = ref<string | number | null>(null);
const modal = ref(false);
const perfil = ref(false);
const version = useRuntimeConfig().public.APP_VERSION;

const { user } = storeToRefs(authStore);
// METHODS

const showModal = (id: string | number | null = null) => {
  modal.value = true;
  currentId.value = id;
};

const logout = () => authStore.logout();

const avatarPath = computed(() => resolveAssetUrl(user.value?.avatar?.icone));
const avatarFalhou = ref(false);
const primeiroNome = computed(() => user.value?.nome?.split(' ')[0] ?? '');

</script>

<style scoped>
.topbar-usuario-activator {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.25rem 0.5rem 0.25rem 0.3rem;
  border-radius: 999px;
  transition: background-color var(--ts-fast) ease;
}
.topbar-usuario-activator:hover {
  background-color: var(--bg-hover);
}
.activator-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 0 0 2px var(--bg-primary), 0 0 0 3px var(--primary);
}
.activator-texto {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}
.activator-texto strong {
  font-size: 0.85rem;
  color: var(--text-primary);
}
.activator-texto small {
  font-size: 0.72rem;
  color: var(--text-secondary);
}

.topbar-usuario-content {
  width: 300px;
}

.topbar-usuario-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 1rem;
}
.usuario-avatar {
  border-radius: 50%;
  -webkit-filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3));
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3));
}
.topbar-usuario-text {
  display: flex;
  flex-direction: column;
  color: #FFFFFF;
  /* sem isso o item flex nunca encolhe abaixo do conteúdo e o e-mail vaza do popover */
  min-width: 0;
}
.topbar-usuario-text > * {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.topbar-usuario-name {
  font-size: 1.2rem;
}
.topbar-usuario-role,
.topbar-usuario-email {
  font-size: 0.9rem;
  color: var(--text-secondary);
}
.topbar-usuario-versao {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--border-primary);
  font-size: 0.72rem;
  color: var(--text-tertiary);
}
.topbar-usuario-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}

</style>